<template>
  <div class="access-denied">
    <i class="fa fa-exclamation-triangle"></i> Access denied by application security check. If you think you should have access please contact your local sales representative or send an email to
    <a href="mailto:seedselector@agconnections.com">Support Email</a>
  </div>
</template>

<script>
export default {
  name: "Authorization",
  methods: {},
  created() {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.access-denied{
  background: #fcf8e3;
  width: 60%;
  position: absolute;
  left: 50%;
  top: 50%;
  color: #000;
  font-size: 18px;
  box-shadow: 0 0 6px rgba(0,0,0,.16);
  transform: translate(-50%, -50%);
  padding: 10px 1rem;
  border-radius: 3px;
}

.access-denied i{
  color: #f7941d;
  font-size: 23px;
  float: left;
  margin: 3px 10px 0 0;
}
</style>
